<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc">Table of Contents</h1>
<p class="toc"><a class="hlink" href="#/OEBPS/tp.htm">Butterfly</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795345395_tp.htm">Bloodlines</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795345425_tp.htm">Mimosa Grove</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/other.htm">Other Books by Sharon Sala</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ata.htm">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maintoc.vue?72a70e4b